import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopiiComponent } from './copii.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { AddCopiiComponent } from './add-copii/add-copii.component';
import { EditCopiiComponent } from './edit-copii/edit-copii.component';

@NgModule({
    declarations: [CopiiComponent, AddCopiiComponent, EditCopiiComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatSliderModule
    ],
    exports: [CopiiComponent]
})
export class CopiiModule { }
